
import { computed, defineComponent, Ref } from 'vue';
import useStore from '@/shared/stores/useStore';
import dictionaryService from '@/core/dictionary/dictionary.service';

export default defineComponent({
    name: 'StoreName',
    components: {},
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup(props) {
        const store = useStore(props.id);

        const name: Ref<string> = computed(() => {
            return dictionaryService.format(props.label, [store.value?.name ?? '']);
        });

        return {
            name,
        };
    },
});
